import classnames from 'classnames'
import { useEffect, useState } from 'react'

import type { ReactNode, ReactElement } from 'react'

import Badge from '~/components/Badge'
import Label from '~/components/Label'

import './styles.scss'

export interface Tab {
  component?: ReactNode
  itemsCount?: number
  label: string | ReactElement
  name: string
}

export interface Props {
  className?: string
  currentTab?: string
  onClickTab?: (tabName: string) => void
  tabsData: Tab[]
}

const Tabs = ({ className, currentTab, onClickTab, tabsData }: Props): ReactElement => {
  /** Local state */

  const [activeTabName, setActiveTabName] = useState(tabsData[0]?.name)

  /** Effects */

  useEffect(() => {
    if (currentTab && currentTab !== activeTabName) {
      setActiveTabName(currentTab)
    }
  }, [activeTabName, currentTab])

  /** Handlers */

  const handleClickHeaderTab = (tabName: string) => () => {
    setActiveTabName(tabName)
    onClickTab && onClickTab(tabName)
  }

  /** Render */

  const TabComponent = tabsData.find(({ name }) => activeTabName === name)?.component

  return (
    <div className="tabs-component-container">
      <div className={classnames('tabs-component', className)}>
        {tabsData.map(({ itemsCount, label, name }) => (
          <div
            className={classnames('tab-component', { 'tab-component--active': name === activeTabName })}
            key={name}
            onClick={handleClickHeaderTab(name)}
          >
            {typeof label === 'string' ? <Label className="tab-component__label" label={label} /> : label}
            {itemsCount !== undefined ? <Badge className="item-count-badge" value={itemsCount} /> : null}
          </div>
        ))}
      </div>
      {TabComponent}
    </div>
  )
}

export default Tabs
